module.exports = __webpack_public_path__ + "media/5-star-wish-reveal-first.9085501e.mp3";